import * as Yup from 'yup';

export const hsCodeValidationSchema = Yup.object().shape({
  name: Yup.string().required('The ingredient name is required')
});



// WEBPACK FOOTER //
// ./src/validation/hsCode.js